// components
import { CenterPageTemplate } from '@/pwa/templates/CenterPageTemplate/CenterPageTemplate';
import { FloatingContent } from '@/pwa/molecules/FloatingContent/FloatingContent';

export interface AccountCreatedV2Props {
  onContinue: () => void;
}

export const AccountCreatedV2 = ({ onContinue }: AccountCreatedV2Props) => {
  return (
    <CenterPageTemplate>
      <FloatingContent
        title='Account Created'
        description='Next, we need to verify your account.'
        actions={[
          {
            label: 'Continue To Verification',
            variant: 'primary',
            onClick: onContinue,
          },
        ]}
      />
    </CenterPageTemplate>
  );
};

AccountCreatedV2.displayName = 'AccountCreatedV2';
export default AccountCreatedV2;
